// import React from 'react'

// // Images
// import AboutMePoster from "../Assets/img/AboutMeImage.png"

// const Aboutme = () => {
//   return <>
//       <div className='sectionContainer'>

//         <div className='aboutMeContainer'>

//           {/* About Me Section Banner */}
//           <div className='aboutMePosterContainer'>
//             <img src={AboutMePoster} alt='Poster' className='aboutMePoster'/>
//           </div>

//           {/* About Me In Detail */}
//           <div className='aboutMeDesc'>
//             <h1 className='sectionName'>About Me</h1>
//             <h1 className='sectionHeadline'>Full-Stack Web Developer👨‍💻</h1>
//             <p className='aboutMePara aboutMePara1'>
//             Hi, I'm Amanuel Abera! <br/><br/>A Full-Stack Web Developer specializing in building scalable web applications using the MERN stack (MongoDB, Express.js, React.js, Node.js). I excel at creating dynamic, user-friendly solutions that solve real-world problems. Passionate about leveraging modern technologies, I aim to contribute to innovative projects that have a real-world impact.
//             </p>

//             <p className='aboutMePara aboutMePara1'>
//             Feel free to explore my projects in the Showcase section below, where you'll find live demos, GitHub repositories, and Docker images that showcase my work.
//             </p>

//             <p className='aboutMePara'>
//             <em className='emPara'>I am currently open to new opportunities. Feel free to connect with me to discuss potential collaborations!</em>
//             </p>
//             <div className='btnContainer aboutBtnContainer'>
//               <a href='#Contact' className='primaryBtn'>Let's Connect</a>
//               <a href='https://drive.google.com/file/d/1XIENcvUVY3Z-4UbmVAgAyHPnmiB9o5E8/view?usp=sharing' target='_blank' className='secondaryBtn'>Download CV</a>
//             </div>
//           </div>

//         </div>

//       </div>
//   </>
// }

// export default Aboutme

import React from 'react';

// Images
import AboutMePoster from '../Assets/img/AboutMeImage.png';

const Aboutme = () => {
  return (
    <>
      <div className="sectionContainer">
        <div className="aboutMeContainer">
          {/* About Me Section Banner */}
          <div className="aboutMePosterContainer">
            <img src={AboutMePoster} alt="Poster" className="aboutMePoster" />
          </div>

          {/* About Me In Detail */}
          <div className="aboutMeDesc">
            <h1 className="sectionName">About Me</h1>
            <h1 className="sectionHeadline">Full-Stack Web Developer 👨‍💻</h1>

            <p className="aboutMePara aboutMePara1">
              Hi, I'm Amanuel Abera! <br />
              <br />
              I'm a Full-Stack Web Developer building SaaS platforms, AI-powered
              applications, and real-time systems.
            </p>

            <p className="aboutMePara aboutMePara1">
              My core stack includes React, TypeScript, Node.js, and NestJS,
              with hands-on experience across frontend development, backend
              services, databases, cloud infrastructure, and third-party
              integrations.
            </p>

            <p className="aboutMePara aboutMePara1">
              I've worked on production applications across hotel management and
              booking, AI-powered data analysis, real-time fleet management,
              e-commerce, and gym management. I enjoy turning complex
              requirements into reliable, maintainable software and taking
              products from ideas to production.
            </p>

            <p className="aboutMePara">
              <em className="emPara">
                I am currently open to new opportunities and collaborations.
                Feel free to connect with me!
              </em>
            </p>

            <div className="btnContainer aboutBtnContainer">
              <a href="#Contact" className="primaryBtn">
                Let's Connect
              </a>
              <a
                href="https://drive.google.com/file/d/1XIENcvUVY3Z-4UbmVAgAyHPnmiB9o5E8/view?usp=sharing"
                target="_blank"
                rel="noreferrer"
                className="secondaryBtn"
              >
                Download CV
              </a>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Aboutme;
